export class DeleteUsersSuccess {
    static readonly type = '[User] DeleteUsersSuccess';

    constructor(
        public payload: {
            entityIds: string[];
        }
    ) {}
}
